<template>
  <div class="contain">
    <div class="amap-wrapper">
      <el-amap vid="amapDemo" :center="center" :zoom="zoom" >
        <el-amap-marker v-for="(marker, index) in markers" :icon="marker.icon"  :position="marker.position" :visible="marker.visible" :draggable="marker.draggable" :vid="index"></el-amap-marker>
        <el-amap-text v-for="text in texts" :text="text.text" :offset="text.offset" :position="text.position" ></el-amap-text>
      </el-amap>
    </div>
    <div class="footer">
      <div style="margin-bottom: 10px;display: flex;align-items: center">
        <van-icon name="warning" color="#F55456"/>
        <span style="font-weight: bold;margin-left: 5px">注意：</span></div>
      <div style="margin-bottom: 10px">1. 车辆的GPS信息仅供参考；</div>
      <div>2. 如果车辆位置一直未更新，请刷新页面再试。</div>
      <div style="text-align: center;"><van-button @click="tip" style="background: #5C77FE; color: #FFFFFF;">点我开始上报位置</van-button></div>

      <van-tabbar v-model="active" active-color="rgb(12, 200, 147)" inactive-color="#FFFFFF"
                  style="background:#5083ED ">
        <van-tabbar-item :icon="car" to="/busIndex">预定巴士</van-tabbar-item>
        <van-tabbar-item :icon="scan" to="/ticketList">乘车验票</van-tabbar-item>
        <van-tabbar-item :icon="user" to="/user">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import Title from './../../components/header'
import {Row, Col, Divider, Button, Rate, Tag, Field, CellGroup, Icon, Tabbar, TabbarItem} from 'vant';

import wx from 'weixin-js-sdk'
import request from '../../utils/request';
import chengK from './../../static/images/chengk.png'
import xingC from './../../static/images/xingC.png'
import push from './../../static/images/push.png'
import person from './../../static/images/chengk.png'
import busIcon from './../../static/images/busIcon3.png'
import meIcon from './../../static/images/meIcon.png'
import user from "../../static/images/busTrip/user.png";
import car from "../../static/images/busTrip/car.png";
import scan from "../../static/images/busTrip/scan.png";

const exampleComponents = {
  props: ['text'],
  template: `
            <div>text from parent: {{text}}</div>`
};
export default {
  name: "busDriverPosition",
  components: {
    Title,
    // aMap,
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      active: "",
      title: "车主位置",
      passengerPosition: {
        lat: "39.865042",
        lon: "116.379028"
      },
      driverPosition: {
        lat: "39.865042",
        lon: "116.379028"
      },
      ticketId: "",
      chengK: chengK,
      xingC: xingC,
      push: push,
      person: person,
      busIcon: busIcon,
      meIcon: meIcon,
      slotStyle: {
        padding: '2px 8px',
        background: '#eee',
        color: '#333',
        border: '1px solid #aaa'
      },
      zoom: 17,
      center: [116.403912,39.894243],
      markers: [],
      texts: [],
      user: user,
      car: car,
      scan: scan,
    }
  },
  created() {
    this.ticketId = this.$route.query.ticketId;
  },

  mounted() {
    this.wxSign();
    this.getOwnerPosition();
    this.init();
    this.noSleep();
  },
  methods: {
    init(){
      setInterval(()=>{
        this.markers=[];
        this.texts=[]
        this.getOwnerPosition();
      },5000);
    },
    tip(){
      this.$toast.success('开始上报，上高速前请勿关闭手机屏幕！！！');
    },
    //自身位置
    wxSign() {
      let me = this;
      request.sendGet({
        url: "/wx/pay/signature",
        params: {
          url: location.href
        }
      }).then(res => {
        if (res.data.code === 0) {
          var data = res.data.data;
          wx.config({
            beta: true,// 必须这么写，否则在微信插件有些jsapi会有问题
            appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: parseInt(data.timestamp, 10), // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature,// 必填，签名，见附录1
            jsApiList: ['getLocation', 'openLocation','hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: [
                'getLocation'
              ]
            });

            wx.hideOptionMenu();
          });
          wx.error(function (res) {
            console.log(res);
          });
        }
      })
    },
    getOwnerPosition(){
      let me = this;
      wx.getLocation({
        type:"gcj02",
        success: function (res) {
          // me.passengerPosition.lat = res.latitude;
          // me.passengerPosition.lon = res.longitude;
          me.addMarker(res,'当前位置', meIcon);
          me.center = [res.longitude, res.latitude];
          request.sendPost({
            url: "/bus/location/1",
            params: {
              latitude:res.latitude,
              longitude:res.longitude
            }
          })
        },
        fail: function (error) {
          this.$toast.fail("获取地理位置失败，请确保开启GPS且允许微信获取您的地理位置！");
        }
      });
    },
    addMarker(position,type, icon) {
      let text= {
        position:[position.longitude, position.latitude],
        text:type,
        offset: [0, 25],
      };
      let marker = {
        position:[position.longitude, position.latitude],

        icon: icon,
        visible: true,
        draggable: false,
      };
      this.markers.push(marker);
      this.texts.push(text);
    },
    noSleep () {
      let noSleep = new this.$NoSleep();
      document.addEventListener('click',
          function enableNoSleep () {undefined
            noSleep.enable();
            document.removeEventListener('click', enableNoSleep, false);
          },
          false);
    },
    // getAddress(){},

  }
}
</script>


<style scoped>
.contain {
  width: 100%;
}

.footer {
  width: 88%;
  margin: 0 auto 55px;
  padding: 15px 10px;
  background: #FFFFFF;
  font-size: 14px;
  color: #202020;
}

.amap-wrapper {
  width: 100%;
  height: 450px;
}
</style>
